import React, { useEffect, useState } from 'react';
import {
  Button,
  Col,
  DatePicker,
  Input,
  Modal as ModalAntd,
  Row,
  Space,
  Table,
  Tag,
  Tooltip,
} from 'antd';
import {
  ReloadOutlined,
  SearchOutlined,
  EyeOutlined,
  FileDoneOutlined,
  FileExcelFilled,
  FilePdfFilled,
} from '@ant-design/icons';
import { METHOD_GET } from '../../../../utils/constants';
import { fetchApi } from '../../../../helpers/fetch';
import moment from 'moment';
import XLSX from 'xlsx';
import {
  SERVICES_CATALOG_ID,
  OPERACIONES_CATALOG_ID,
} from '../../../../helpers/constants';
import { getCatalogValueHandle } from '../../../../helpers/handlerFunctionApi';
import Highlighter from 'react-highlight-words';
import jsPDF from 'jspdf';
import { getAccessTokenApi } from '../../../../api/auth';
import Modal from '../../../General/Modal';
import AddEditOperationForm from '../../../Logistic/Operations/AddEditOperationForm';
import UploadFileForm from '../../Payment/UploadFileForm';
import AddBillingForm from '../../Billling/AddBillingForm';
import { getFilteredDataFromLocalStorage, saveFilteredDataToLocalStorage } from '../../../../helpers/saveFilterData';
import useUser from '../../../../hooks/useUser';
import UploadFileEUForm from '../../Payment/UploadFileEUForm/UploadFileEUForm';

const SupplierOperationsTable = () => {
  const [modalIsVisible, setModalIsVisible] = useState(false);
  const [titleModal, setTitleModal] = useState(false);
  const [contextModal, setContextModal] = useState(null);
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const { confirm } = ModalAntd;
  const [isLoading, setIsLoading] = useState(true);
  const token = getAccessTokenApi();
  const [reloadTable, setReloadTable] = useState(false);
  const [operations, setOperations] = useState([]);
  const [service, setService] = useState([]);
  const [operaciones, setOperaciones] = useState([]);
  const [filterService, setFilterService] = useState([]);
  const [filterOperaciones, setFilterOperaciones] = useState([]);
  const [searchedColumn, setSearchedColumn] = useState('');
  const [filteredInfo, setFilteredInfo] = useState({});
  const [searchText, setSearchText] = useState('');
  const [startDate, setStartDate] = useState({
    createdAt: '',
    etd: '',
    eta: '',
  });
  const [endDate, setEndDate] = useState({
    createdAt: '',
    etd: '',
    eta: '',
  });
  const x = React.createRef();
  const { person } = useUser();
  let [isSupplierEUA, setIsSupplierEUA] = useState(false);

  useEffect(() => {
    if (person.roles.includes('Supplier') && person.country === 30) {
      setIsSupplierEUA(true);
    }
  }, [person]);

  const onSelectChange = (selectedRowKeys, selectedRows) => {
    setSelectedRowKeys(selectedRowKeys);
  };
  useEffect(() => {
    getCatalogValueHandle(SERVICES_CATALOG_ID, setService, setIsLoading, 0);
    getCatalogValueHandle(
      OPERACIONES_CATALOG_ID,
      setOperaciones,
      setIsLoading,
      0
    );
  }, []);
  useEffect(() => {
    setIsLoading(true);

    const config = {
      method: METHOD_GET,
      url: `Supplier/Operations`,
      data: null,
      token,
      showNotificationError: true,
    };
    fetchApi(config)
      .then((response) => {
        if (response.statusCode === 200) {
          const allOperations = response.result;
          allOperations.map((operation) => (operation['key'] = operation.id));
          setOperations(allOperations);
        }
        setIsLoading(false);
        setReloadTable(false);
      })
      .catch((err) => {
        console.log(err);
        setIsLoading(false);
        setReloadTable(false);
      });
  }, [reloadTable, token]);
  useEffect(() => {
    let filters = [];
    service.forEach((element) => {
      const json = { text: element.label, value: element.label };
      filters.push(json);
    });
    setFilterService(filters);
  }, [service]);
  useEffect(() => {
    let filters = [];
    operaciones.forEach((element) => {
      const json = { text: element.label, value: element.label };
      filters.push(json);
    });
    setFilterOperaciones(filters);
  }, [operaciones]);
  useEffect(() => {
    const datosObtenidos = getFilteredDataFromLocalStorage('supplierOperations');
    if (datosObtenidos !== null) {
      setFilteredInfo(datosObtenidos.filters);
      setStartDate(datosObtenidos.dateFilters.startDates)
      setEndDate(datosObtenidos.dateFilters.endDates)
    }
  },[])
  const handleReset = React.useCallback(
    (clearFilters, selectedKeys, confirm, dataIndex) => {
      clearFilters();
      setSearchText('');
      startDate[dataIndex] = '';
      endDate[dataIndex] = '';
    },
    [endDate, startDate]
  );
  const getColumnSearchProps = React.useCallback(
    (dataIndex) => ({
      filterDropdown: ({
        setSelectedKeys,
        selectedKeys,
        confirm,
        clearFilters,
      }) => (
        <div style={{ padding: 8 }}>
          <Input
            ref={(node) => {
              // this.searchInput = node;
            }}
            placeholder={`Buscar`}
            value={selectedKeys[0]}
            onChange={(e) =>
              setSelectedKeys(e.target.value ? [e.target.value] : [])
            }
            onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
            style={{ marginBottom: 8, display: 'block' }}
          />
          <Space>
            <Button
              type="primary"
              onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
              icon={<SearchOutlined />}
              size="small"
              style={{ width: 90 }}
            >
              Buscar
            </Button>
            <Button
              onClick={() => {
                handleReset(clearFilters);
                handleSearch(selectedKeys, confirm, dataIndex);
              }}
              size="small"
              style={{ width: 90 }}
            >
              Limpiar
            </Button>
          </Space>
        </div>
      ),
      filterIcon: (filtered) => (
        <SearchOutlined style={{ color: filtered ? '#1890ff' : undefined }} />
      ),
      onFilter: (value, record) =>
        record[dataIndex]
          ? record[dataIndex]
              .toString()
              .toLowerCase()
              .includes(value.toLowerCase())
          : '',
      filteredValue: filteredInfo[dataIndex] || null,
      onFilterDropdownVisibleChange: (visible) => {},
      render: (text) =>
        searchedColumn === dataIndex ? (
          <Highlighter
            highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
            searchWords={[searchText]}
            autoEscape
            textToHighlight={text ? text.toString() : ''}
          />
        ) : (
          text
        ),
    }),
    [filteredInfo, handleReset, searchText, searchedColumn]
  );
  const getColumnSearchDateProps = React.useCallback(
    (dataIndex) => ({
      filterDropdown: ({
        setSelectedKeys,
        selectedKeys,
        confirm,
        clearFilters,
      }) => (
        <div style={{ padding: 8 }}>
          <Col>
            <DatePicker
              ref={x}
              id={'startDate' + dataIndex}
              placeholder={'Fecha inicial'}
              style={{ marginRight: '10px' }}
              format="DD/MM/YYYY"
              allowClear={false}
              value={
                startDate[dataIndex] !== ''
                  ? moment.unix(startDate[dataIndex])
                  : null
              }
              onChange={(e) => {
                // setStartDate(moment(e).unix());
                startDate[dataIndex] = moment(e).startOf('day').unix();
                setSelectedKeys(
                  operations
                    .filter(
                      (op) =>
                        moment(e)
                          .hours(0)
                          .minutes(0)
                          .seconds(0)
                          .milliseconds(0)
                          .unix() <= op[dataIndex]
                    )
                    .map((op) => op.key)
                );

                // setSelectedKeys(e !== null ? [e.format('DD/MM/YYYY')] : [])
              }}
            />
            <DatePicker
              placeholder={'Fecha final'}
              format="DD/MM/YYYY"
              allowClear={false}
              value={
                endDate[dataIndex] !== ''
                  ? moment.unix(endDate[dataIndex])
                  : null
              }
              onChange={(e) => {
                // setEndDate(moment(e).unix());
                endDate[dataIndex] = moment(e).endOf('day').unix();
                setSelectedKeys(
                  operations
                    .filter(
                      (op) =>
                        op[dataIndex] <=
                        moment(e)
                          .hours(23)
                          .minutes(59)
                          .seconds(59)
                          .milliseconds(0)
                          .unix()
                    )
                    .map((op) => op.key)
                );
              }}
            />
          </Col>
          <Row justify="end" gutter={16}>
            <Col>
              <Button
              disabled={endDate[dataIndex] === ''}
                type="primary"
                onClick={() => {
                  handleSearchDate(selectedKeys, confirm);
                  setSelectedKeys(
                    operations
                      .filter(
                        (d) =>
                          startDate[dataIndex] <= d[dataIndex] &&
                          d[dataIndex] <= endDate[dataIndex]
                      )
                      .map((d) => d.key)
                  );
                }}
                icon={<SearchOutlined />}
                size="small"
                style={{ width: 90 }}
              >
                Buscar
              </Button>
              <Button
                onClick={() => {
                  handleReset(clearFilters, selectedKeys, confirm, dataIndex);
                  handleSearchDate(selectedKeys, confirm, dataIndex);
                }}
                size="small"
                style={{ width: 90 }}
              >
                Limpiar
              </Button>
            </Col>
          </Row>
        </div>
      ),
      filterIcon: (filtered) => (
        <SearchOutlined style={{ color: filtered ? '#1890ff' : undefined }} />
      ),
      onFilter: (value, record) =>
        startDate[dataIndex] <= record[dataIndex] &&
        record[dataIndex] <= endDate[dataIndex],
      filteredValue: filteredInfo[dataIndex] || null,
      onFilterDropdownVisibleChange: (visible) => {},
      render: (text) =>
        searchedColumn === dataIndex ? (
          <Highlighter
            highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
            searchWords={[searchText]}
            autoEscape
            textToHighlight={text ? moment.unix(text).format('DD/MM/YYYY') : ''}
          />
        ) : (
          moment.unix(text).format('DD/MM/YYYY')
        ),
    }),
    [
      endDate,
      filteredInfo,
      handleReset,
      operations,
      searchText,
      searchedColumn,
      startDate,
      x,
    ]
  );
  const handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    setSearchText(selectedKeys[0]);
    setSearchedColumn(dataIndex);
  };
  const handleSearchDate = (selectedKeys, confirm, dataIndex) => {
    confirm();
  };
  const handleChange = (pagination, filters, sorter, extra) => {
    const dateFilters = { startDates: startDate, endDates: endDate}
    saveFilteredDataToLocalStorage('supplierOperations', pagination, sorter, filters,dateFilters);
    setFilteredInfo(filters);
  };
  const showModal = React.useCallback(
    (
      type,
      billingFields,
      fileXml,
      filePdf,
      fileCfdi,
      nameXml,
      operation,
      operationId
    ) => {
      if (type === 'Watch') {
        setModalIsVisible(true);
        setTitleModal(`Operación #${operation.operationIdStr}`);
        setContextModal(
          <AddEditOperationForm
            type="watch"
            setModalIsVisible={setModalIsVisible}
            operationId={operation.id}
          ></AddEditOperationForm>
        );
      } else if (type === 'addBillForm') {
        setModalIsVisible(true);
        setTitleModal('');
          setContextModal(
            <AddBillingForm
              setModalVisible={setModalIsVisible}
              billingFields={billingFields}
              fileXml={fileXml}
              filePdf={filePdf}
              fileCfdi={fileCfdi}
              nameXml={nameXml}
              operationId={operationId}
              setReloadTable={setReloadTable}
            ></AddBillingForm>
          );
      } else if (type === 'addFile') {
        setModalIsVisible(true);
        setTitleModal(`Operación #${operation.operationIdStr} a facturar`);
        if (isSupplierEUA === false) {
          setContextModal(
            <UploadFileForm
              setModalIsVisible={setModalIsVisible}
              showModal={showModal}
              type={type}
              operationId={operation.operationIdStr}
            ></UploadFileForm>
          ); 
        }else if(isSupplierEUA === true){
          setContextModal(
            <UploadFileEUForm
              setModalIsVisible={setModalIsVisible}
              setReloadTable={setReloadTable}
              operationId={operation.operationIdStr}
              showModal={showModal}

            ></UploadFileEUForm>
          );
        }
      }
    },
    [setModalIsVisible, setReloadTable, setContextModal,isSupplierEUA]
  );
  const columns = React.useMemo(
    () => [
      {
        title: 'Id. operación',
        dataIndex: 'operationIdStr',
        key: 'operationIdStr',
        width: 100,
        align: 'center',
        ...getColumnSearchProps('operationIdStr'),
      },
      {
        title: 'Fecha operación',
        dataIndex: 'createdAt',
        key: 'createdAt',
        width: 100,
        align: 'center',
        render: (createdAt) => (
          <>{moment.unix(createdAt).format('DD/MM/YYYY')}</>
        ),
        ...getColumnSearchDateProps('createdAt'),
      },
      {
        title: 'Proveedor',
        dataIndex: 'supplier',
        key: 'supplier',
        width: 150,
        align: 'center',
        ...getColumnSearchProps('supplier'),
      },
      {
        title: 'Orden de compra',
        dataIndex: 'purchaseOrder',
        key: 'purchaseOrder',
        width: 160,
        align: 'center',
        ellipsis: true,
        ...getColumnSearchProps('purchaseOrder'),
      },
      {
        title: 'Servicio',
        dataIndex: 'service',
        key: 'service',
        width: 100,
        align: 'center',
        filters: filterService,
        filteredValue: filteredInfo.service || null,
        onFilter: (value, record) => record.service.includes(value),
      },
      {
        title: 'Operación',
        dataIndex: 'operation',
        key: 'operation',
        width: 100,
        align: 'center',
        filters: filterOperaciones,
        filteredValue: filteredInfo.operation || null,
        onFilter: (value, record) => record.operation === value,
      },
      {
        title: 'Origen',
        dataIndex: 'originCity',
        key: 'originCity',
        width: 150,
        align: 'center',
        ...getColumnSearchProps('originCity'),
      },
      {
        title: 'Destino',
        dataIndex: 'destinationCity',
        key: 'destinationCity',
        width: 150,
        align: 'center',
        ...getColumnSearchProps('destinationCity'),
      },
      {
        title: 'ETD',
        dataIndex: 'etd',
        key: 'etd',
        width: 100,
        align: 'center',
        render: (etd) => <>{moment.unix(etd).format('DD/MM/YYYY')}</>,
        ...getColumnSearchDateProps('etd'),
      },
      {
        title: 'ETA',
        dataIndex: 'eta',
        key: 'eta',
        width: 100,
        align: 'center',
        render: (eta) => (
          <>{eta && <>{moment.unix(eta).format('DD/MM/YYYY')}</>}</>
        ),
        ...getColumnSearchDateProps('eta'),
      },
      {
        title: 'Estatus',
        dataIndex: 'status',
        key: 'status',
        width: 100,
        align: 'center',
        filters: [
          { text: 'Programado', value: 'Programado' },
          { text: 'Cargando', value: 'Cargando' },
          { text: 'En transito', value: 'En transito' },
          { text: 'Descargado', value: 'Descargado' },
          { text: 'Entregado', value: 'Entregado' },
          { text: 'Cancelado', value: 'Cancelado' },
        ],
        filteredValue: filteredInfo.status || null,
        onFilter: (value, record) => record.status.includes(value),
        render: (status) => (
          <Tag
            color={
              status === 'Programado'
                ? '#c2c0c0'
                : status === 'En transito'
                ? 'yellow'
                : status === 'Entregado'
                ? 'green'
                : status === 'Descargado'
                ? 'blue'
                : status === 'Cargando'
                ? 'orange'
                : 'red'
            }
          >
            {status}
          </Tag>
        ),
      },
      {
        title: 'Estatus facturación',
        dataIndex: 'apInvoiceStatus',
        key: 'apInvoiceStatus',
        width: 100,
        align: 'center',
        filters: [
          { text: 'POR FACTURAR', value: 'Por facturar' },
          { text: 'VIGENTE', value: 'VIGENTE' },
          { text: 'PAGADO', value: 'PAGADO' },
        ],
        filteredValue: filteredInfo.apInvoiceStatus || null,
        onFilter: (value, record) => record.apInvoiceStatus === value,
        render: (apInvoiceStatus, operation) => (
          <Tag
            color={
              apInvoiceStatus === 'VIGENTE'
                ? 'blue'
                : apInvoiceStatus === 'PAGADO'
                ? 'green'
                : apInvoiceStatus === 'Por facturar'
                ? 'red'
                : ''
            }
          >
            {operation.orderStatus !== 3 ? apInvoiceStatus : ''}
          </Tag>
        ),
      },

      {
        title: 'Acciones',
        key: 'id',
        fixed: 'right',
        width: 160,
        align: 'center',
        render: (operation, record) => (
          <>
            <Tooltip title="Ver más información">
              <Button
                style={{ marginLeft: 3 }}
                type="primary"
                ghost
                shape="default"
                icon={<EyeOutlined />}
                onClick={() =>
                  showModal('Watch', '', '', '', '', '', operation)
                }
              />
            </Tooltip>
            <Tooltip title="Facturación">
              <Button
                style={{ marginLeft: 3 }}
                type="primary"
                ghost
                // disabled={
                //   operation.orderStatus !== 2 ||
                //   operation.apInvoiceStatus !== 'Por facturar'
                // }
                shape="default"
                icon={<FileDoneOutlined />}
                onClick={() =>
                  showModal(
                    'addFile',
                    '',
                    '',
                    '',
                    '',
                    '',
                    operation,
                    operation.invoiceId
                  )
                }
              />
            </Tooltip>
          </>
        ),
      },
    ],
    [
      filterOperaciones,
      filterService,
      filteredInfo,
      getColumnSearchDateProps,
      getColumnSearchProps,
      showModal,
    ]
  );
  const generateExcel = (entries) => {
    // setExcelLoading(true);
    let filename = '';
    let mstrTitulo = '';

    filename = `Operaciones${moment().format('L')}.xlsx`;
    mstrTitulo = `Operaciones`;
    let fecha = moment().format('LLL');
    const ws_name = 'Hoja1';
    let wb = {
      SheetNames: [],
      Sheets: {},
    };
    let ws = {};
    let renInicial = 4;

    // var mstrTitulo = `Facturación y notas de crédito del ${dateRange.startDate} al: ${dateRange.endDate}`;

    ws = {
      A1: { v: mstrTitulo, t: 's' },
      I1: { v: fecha, t: 's' },

      A3: { v: 'Id. operación', t: 's' },
      B3: { v: 'Fecha operación', t: 's' },
      C3: { v: 'Proveedor', t: 's' },
      D3: { v: 'Orden de compra', t: 's' },
      E3: { v: 'Servicio', t: 's' },
      F3: { v: 'Operación', t: 's' },
      G3: { v: 'Origen', t: 's' },
      H3: { v: 'Destino', t: 's' },
      I3: { v: 'ETD', t: 's' },
      J3: { v: 'ETA', t: 's' },
      K3: { v: 'Estatus', t: 's' },
      L3: { v: 'Estatus facturación', t: 's' },
    };
    for (let i in entries) {
      const {
        operationIdStr,
        createdAt,
        supplier,
        purchaseOrder,
        service,
        operation,
        originCity,
        destinationCity,
        etd,
        eta,
        status,
        apInvoiceStatus,
      } = entries[i];
      ws['A' + renInicial] = { v: operationIdStr, t: 's' };
      ws['B' + renInicial] = {
        v: moment.unix(createdAt).format('DD/MM/YYYY'),
        t: 's',
      };
      ws['C' + renInicial] = { v: supplier, t: 's' };
      ws['D' + renInicial] = { v: purchaseOrder, t: 's' };
      ws['E' + renInicial] = { v: service, t: 's' };
      ws['F' + renInicial] = { v: operation, t: 's' };
      ws['G' + renInicial] = { v: originCity, t: 's' };
      ws['H' + renInicial] = { v: destinationCity, t: 's' };
      ws['I' + renInicial] = {
        v: moment.unix(etd).format('DD/MM/YYYY'),
        t: 's',
      };
      ws['J' + renInicial] = {
        v: moment.unix(eta).format('DD/MM/YYYY'),
        t: 's',
      };
      ws['K' + renInicial] = { v: status, t: 's' };
      ws['L' + renInicial] = { v: apInvoiceStatus, t: 's' };

      renInicial++;
    }
    // var wscols = [{ wch: 30 }, { wch: 40 }, { wch: 35 }, { wch: 35 }];
    // ws['!cols'] = wscols;
    ws['!ref'] = XLSX.utils.encode_range({
      s: { c: 0, r: 0 },
      e: { c: 15, r: renInicial },
    });
    wb.SheetNames.push(ws_name);
    wb.Sheets[ws_name] = ws;
    XLSX.writeFile(wb, filename, { cellStyles: true });
    // setExcelLoading(false);
  };
  const exportPdf = (operations, startDate, endDate) => {
    let mstrTitulo = '';
    let mstrPdf = '';

    mstrTitulo = `Operaciones`;
    mstrPdf = `Operaciones${moment().format('L')}.pdf`;
    var registros = [];
    operations.forEach((element) => {
      registros.push([
        element.operationIdStr,
        moment.unix(element.createdAt).format('DD/MM/YYYY'),
        element.supplier,
        element.purchaseOrder,
        element.service,
        element.operation,
        element.originCity,
        element.destinationCity,
        moment.unix(element.etd).format('DD/MM/YYYY'),
        moment.unix(element.eta).format('DD/MM/YYYY'),
        element.status,
        element.status === 'Cancelado' ? null : element.apInvoiceStatus,
      ]);
    });

    let fecha = moment().format('LLL');
    let doc = new jsPDF('landscape');
    doc.setFontSize(12);

    let xFecha = 220;
    let yFecha = 10;

    let totalPagesExp = '{total_pages_count_string}';

    let pageContent = function (data) {
      //header
      doc.text(15, 10, mstrTitulo);
      doc.text(-10, -10, mstrTitulo);
      doc.text(fecha, xFecha, yFecha);
      // FOOTER
      let str = 'Página ' + data.pageCount;
      //Total page number plugin only available in jspdf v1.0+
      if (typeof doc.putTotalPages === 'function') {
        str = str + ' de ' + totalPagesExp;
      }
      doc.setFontSize(10);
      doc.text(
        str,
        data.settings.margin.left,
        doc.internal.pageSize.height - 10
      );
    };
    doc.autoTable({
      A3: { v: 'Id. operación', t: 's' },
      B3: { v: 'Fecha operación', t: 's' },
      C3: { v: 'Proveedor', t: 's' },
      D3: { v: 'Orden de compra', t: 's' },
      E3: { v: 'Servicio', t: 's' },
      F3: { v: 'Operación', t: 's' },
      G3: { v: 'Origen', t: 's' },
      H3: { v: 'Destino', t: 's' },
      I3: { v: 'ETD', t: 's' },
      J3: { v: 'ETA', t: 's' },
      K3: { v: 'Estatus', t: 's' },
      L3: { v: 'Estatus facturación', t: 's' },
      head: [
        [
          'Id. operación',
          'Fecha operación',
          'Proveedor',
          'Orden de compra',
          'Servicio',
          'Operación',
          'Origen',
          'Destino',
          'ETD',
          'ETA',
          'Estatus',
          'Estatus facturación',
        ],
      ],
      didDrawPage: pageContent,
      theme: 'grid',
      headStyles: {
        valign: 'middle',
        halign: 'center',
        fillColor: [230, 81, 0],
        textColor: [255, 255, 255],
        // cellWidth: { 3: 200 },
      },
      body: registros,
      columnStyles: {
        0: { halign: 'center', cellWidth: 22, minCellWidth: 10 },
        1: { halign: 'center', cellWidth: 22, minCellWidth: 10 },
        2: { halign: 'center', cellWidth: 22, minCellWidth: 10 },
        3: { halign: 'center', cellWidth: 25, minCellWidth: 10 },
        4: { halign: 'center', cellWidth: 15, minCellWidth: 10 },
      },

      // columnStyles: {
      //   text: {
      //     cellWidth: 'wrap',

      //   },
      // },
    });
    // call footer() after each doc.addPage()
    // and before doc.save() do not forget put
    if (typeof doc.putTotalPages === 'function') {
      doc.putTotalPages(totalPagesExp);
    }
    //spinner.style.display = 'none';
    doc.save(mstrPdf);
  };

  return (
    <div>
      <Button
        className="btn-download"
        icon={<ReloadOutlined />}
        onClick={() => setReloadTable(true)}
      >
        Refrescar
      </Button>

      <Table
        dataSource={operations}
        columns={columns}
        bordered
        size="middle"
        scroll={{ x: 1200 }}
        className="table-striped-rows"
        loading={isLoading || reloadTable}
        onChange={handleChange}
      />
      <Row>
        <Col span={24} style={{ textAlign: 'right' }}>
          <Button
            icon={<FilePdfFilled style={{ fontSize: 18 }} />}
            className="btn-download"
            onClick={() => exportPdf(operations)}
            disabled={operations.length === 0}
            style={{ width: 150 }}
          >
            Descargar Pdf
          </Button>
          <Button
            icon={<FileExcelFilled style={{ fontSize: 18 }} />}
            className="btn-download"
            onClick={() => generateExcel(operations)}
            disabled={operations.length === 0}
            style={{ width: 160 }}
          >
            Descargar Excel
          </Button>
        </Col>
      </Row>

      <Modal
        title={titleModal}
        visible={modalIsVisible}
        setIsVisible={setModalIsVisible}
        width={1000}
      >
        {contextModal}
      </Modal>
    </div>
  );
};

export default SupplierOperationsTable;
